import v from "./index205.mjs";
import k from "./index212.mjs";
import s from "./index210.mjs";
function d(l, i) {
  k(1, arguments);
  var r = i || {}, a = r.locale, n = a && a.options && a.options.weekStartsOn, u = n == null ? 0 : s(n), t = r.weekStartsOn == null ? u : s(r.weekStartsOn);
  if (!(t >= 0 && t <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var e = v(l), o = e.getUTCDay(), f = (o < t ? 7 : 0) + o - t;
  return e.setUTCDate(e.getUTCDate() - f), e.setUTCHours(0, 0, 0, 0), e;
}
export {
  d as default
};
//# sourceMappingURL=index305.mjs.map
